import { __read, __spread } from "tslib";
import { compareNodes } from '@graphql-tools/utils';
function alreadyExists(arr, other) {
    return !!arr.find(function (i) { return i.name.value === other.name.value; });
}
export function mergeNamedTypeArray(first, second, config) {
    var result = __spread(second, first.filter(function (d) { return !alreadyExists(second, d); }));
    if (config && config.sort) {
        result.sort(compareNodes);
    }
    return result;
}
//# sourceMappingURL=merge-named-type-array.js.map